import GeneralUtils from "../../utils/GeneralUtils";

function legalParagraph(html) {
    return "<p style='margin: 0 0 12px 0;'>" + html + "</p>";
}

function memberLegalLabels() {
    const ctx = GeneralUtils.getMemberLegalContext();
    const legal = GeneralUtils.escapeHtml(ctx.legalEntity);
    const trading = GeneralUtils.escapeHtml(ctx.tradingName);
    const tradingAsClause = ctx.showTradingAs
        ? " (trading as <strong>" + trading + "</strong>)"
        : "";
    return {legal, trading, tradingAsClause, ctx};
}

/** UK member checkout / footer — merchant-of-record terms (not a marketplace). */
export function getMemberTermsAndConditionsBodyHtml() {
    const {legal, tradingAsClause} = memberLegalLabels();
    const header = GeneralUtils.getTermsMerchantHeaderHtml();
    return "<div style='text-align: justify; text-justify: inter-word; line-height: 1.6; padding-bottom: 18px;'>" +
        header +
        "<strong>Terms and Conditions \u2013 " + legal + " (UK)</strong>" +
        "<br/><br/>" +
        "<strong>1. Introduction</strong>" +
        "<br/>" +
        legalParagraph(
            "These Terms and Conditions govern your use of this website to place orders with <strong>" + legal + "</strong>" + tradingAsClause + " (\"we\", \"us\", \"our\"). " +
            "By placing an order, you agree to these Terms and Conditions."
        ) +
        legalParagraph(
            "You are purchasing food and goods directly from us. This website is our online ordering channel. " +
            "It is operated using third\u2011party ordering technology; that technology provider is not the seller of your order and does not receive your payment for the goods."
        ) +
        legalParagraph(
            "Our Privacy Policy and Cookie Policy are available via the links in the site footer."
        ) +
        "<br/>" +
        "<strong>2. Eligibility</strong>" +
        "<br/>" +
        "You must be at least 18 years old to place an order. By using this service, you confirm that the information you provide is accurate and complete." +
        "<br/><br/>" +
        "<strong>3. Orders</strong>" +
        "<br/>" +
        "When you place an order, you are making an offer to purchase products from us. " +
        "Once we accept the order and begin preparation, the order becomes binding." +
        "<br/>" +
        "We may refuse or cancel orders for reasons including product unavailability, operational issues, or suspected fraud." +
        "<br/><br/>" +
        "<strong>4. Pricing and Payment</strong>" +
        "<br/>" +
        "All prices displayed include VAT where applicable unless otherwise stated." +
        "<br/><br/>" +
        "Payment must be made at the time of placing the order using the available payment methods." +
        "<br/><br/>" +
        "<strong>4.1 Flow of funds (card and digital wallet payments)</strong>" +
        "<br/>" +
        legalParagraph(
            "When you pay by card, Apple Pay, Google Pay or another digital wallet shown at checkout, <strong>your payment is made to " + legal + "</strong>. " +
            legal + " is the merchant of record for your order."
        ) +
        legalParagraph(
            "Card and wallet payments are processed securely by our payment service provider acting on behalf of " + legal + ". " +
            "Your card statement or wallet receipt should show " + legal + " (or a name we use for card processing that clearly identifies us). " +
            "Funds from your payment are settled to " + legal + "\u2019s merchant account, not to the ordering technology provider."
        ) +
        legalParagraph(
            "The ordering technology used on this website does not sell the products to you and does not receive your payment for the order."
        ) +
        "<br/>" +
        "<strong>5. Order Cancellation</strong>" +
        "<br/>" +
        "Orders may be cancelled before we begin preparing the order." +
        "<br/><br/>" +
        "Once food or perishable goods preparation has started, cancellation may not be possible due to the nature of the products." +
        "<br/><br/>" +
        "<strong>6. Delivery and Collection</strong>" +
        "<br/>" +
        "Delivery or collection times provided are estimates only and may vary due to traffic, weather, or operational circumstances." +
        "<br/><br/>" +
        "You must ensure delivery or collection details and contact information are correct. " +
        "If you are unavailable to receive a delivery order, the order may be considered fulfilled." +
        "<br/><br/>" +
        "<strong>7. Refunds and Complaints</strong>" +
        "<br/>" +
        "You may request refunds or replacements where:" +
        "<br/>" +
        "\u2022 The order contains incorrect items" +
        "<br/>" +
        "\u2022 Items are missing" +
        "<br/>" +
        "\u2022 Items arrive damaged" +
        "<br/>" +
        "\u2022 Food or goods are not of satisfactory quality" +
        "<br/><br/>" +
        "Requests should be reported as soon as reasonably possible after delivery or collection." +
        "<br/><br/>" +
        "Refunds will normally be processed to the original payment method unless otherwise agreed." +
        "<br/><br/>" +
        "<strong>8. Perishable Goods</strong>" +
        "<br/>" +
        "Due to the perishable nature of food and grocery items, the right to cancel under the Consumer Contracts Regulations 2013 may not apply once preparation has begun." +
        "<br/><br/>" +
        "<strong>9. Customer Responsibilities</strong>" +
        "<br/>" +
        "You must provide accurate information, ensure someone is available to receive delivery orders where applicable, and use this service lawfully and honestly." +
        "<br/><br/>" +
        "<strong>10. Limitation of Liability</strong>" +
        "<br/>" +
        "Nothing in these Terms excludes liability where it would be unlawful to do so. " +
        "We are not liable for indirect or consequential losses arising from use of this service except as required by law." +
        "<br/><br/>" +
        "<strong>11. Statutory Rights</strong>" +
        "<br/>" +
        "Nothing in these Terms affects your statutory rights under the Consumer Rights Act 2015 or other applicable UK consumer protection laws." +
        "<br/><br/>" +
        "<strong>12. Fraud and Misuse</strong>" +
        "<br/>" +
        "We may refuse service, cancel orders, or refuse refunds where there is evidence of fraud, abuse, or misuse." +
        "<br/><br/>" +
        "<strong>13. Changes to Terms</strong>" +
        "<br/>" +
        "We may update these Terms from time to time. The latest version will always be available on this website." +
        "<br/><br/>" +
        "<strong>14. Governing Law</strong>" +
        "<br/>" +
        "These Terms are governed by the laws of England and Wales. Disputes are subject to the courts of England and Wales." +
        "<br/><br/></div>";
}

/** UK member footer — Privacy Policy (merchant as controller). */
export function getMemberPrivacyPolicyBodyHtml() {
    const {legal, tradingAsClause} = memberLegalLabels();
    const header = GeneralUtils.getTermsMerchantHeaderHtml();
    return "<div style='text-align: justify; text-justify: inter-word; line-height: 1.6; padding-bottom: 18px;'>" +
        header +
        "<strong>Privacy Policy \u2013 " + legal + " (UK)</strong>" +
        "<br/><br/>" +
        "<strong>1. Introduction</strong>" +
        "<br/>" +
        legalParagraph(
            "This Privacy Policy explains how <strong>" + legal + "</strong>" + tradingAsClause + " (\"we\", \"us\") processes personal data when you use this website to browse our menu and place orders. " +
            "It should be read with our Terms &amp; Conditions and Cookie Policy."
        ) +
        "<br/>" +
        "<strong>2. Who we are</strong>" +
        "<br/>" +
        legalParagraph(
            "<strong>" + legal + "</strong> is the data controller for personal data collected through this online ordering website in connection with your order, " +
            "unless we tell you otherwise for a specific purpose."
        ) +
        legalParagraph(
            "We use third\u2011party technology to host and operate this ordering website. That provider processes data on our instructions to run the site and checkout; " +
            "it is not the seller of your order and does not receive your card payment for the goods (see our Terms for flow of funds)."
        ) +
        "<br/>" +
        "<strong>3. Information we collect</strong>" +
        "<br/>" +
        "We may collect and process: name and contact details; delivery or collection address; order contents and history; account details if you register; " +
        "device and technical data (such as IP address and browser type); communications about your order; and payment transaction references from our payment provider." +
        "<br/><br/>" +
        "We do not store your full card number on our servers; card data is handled by our certified payment provider." +
        "<br/><br/>" +
        "<strong>4. How we use your information</strong>" +
        "<br/>" +
        "To take and fulfil orders; to process payments and refunds; to communicate about your order; to prevent fraud; and to meet legal and accounting obligations." +
        "<br/><br/>" +
        "<strong>5. Legal bases (UK GDPR)</strong>" +
        "<br/>" +
        "Contract; legitimate interests (security and service operation) where not overridden by your rights; legal obligation; and consent where required (e.g. certain cookies)." +
        "<br/><br/>" +
        "<strong>6. Sharing your information</strong>" +
        "<br/>" +
        "We may share data with delivery partners where used, our payment service provider, and IT/hosting suppliers acting on our instructions. " +
        "They must protect personal data and use it only for specified purposes." +
        "<br/><br/>" +
        "<strong>7. International transfers</strong>" +
        "<br/>" +
        "If data is transferred outside the UK, we use appropriate safeguards where required by law." +
        "<br/><br/>" +
        "<strong>8. Retention</strong>" +
        "<br/>" +
        "We retain data only as long as necessary for the purposes above, including legal, tax, and dispute requirements." +
        "<br/><br/>" +
        "<strong>9. Your rights</strong>" +
        "<br/>" +
        "You may have rights of access, correction, erasure, restriction, objection, and portability. You may complain to the ICO." +
        "<br/><br/>" +
        "<strong>10. Cookies</strong>" +
        "<br/>" +
        "See our Cookie Policy." +
        "<br/><br/>" +
        "<strong>11. Security</strong>" +
        "<br/>" +
        "We use appropriate measures to protect personal data; no internet transmission is completely secure." +
        "<br/><br/>" +
        "<strong>12. Children</strong>" +
        "<br/>" +
        "This service is not directed at children under 18." +
        "<br/><br/>" +
        "<strong>13. Changes</strong>" +
        "<br/>" +
        "We may update this policy; the latest version will appear on this website." +
        "<br/><br/>" +
        "<strong>14. Contact</strong>" +
        "<br/>" +
        "For privacy requests about your order, contact us using the store contact details shown on this website." +
        "<br/><br/></div>";
}

/** UK member footer — Cookie Policy. */
export function getMemberCookiePolicyBodyHtml() {
    const {legal, tradingAsClause} = memberLegalLabels();
    const header = GeneralUtils.getTermsMerchantHeaderHtml();
    return "<div style='text-align: justify; text-justify: inter-word; line-height: 1.6; padding-bottom: 18px;'>" +
        header +
        "<strong>Cookie Policy \u2013 " + legal + " (UK)</strong>" +
        "<br/><br/>" +
        "<strong>1. What are cookies?</strong>" +
        "<br/>" +
        "Cookies are small text files stored on your device when you visit a website. Similar technologies may also be used." +
        "<br/><br/>" +
        "<strong>2. How we use cookies</strong>" +
        "<br/>" +
        legalParagraph(
            "<strong>" + legal + "</strong>" + tradingAsClause + " uses cookies on this ordering website as follows:"
        ) +
        "<strong>Strictly necessary:</strong> required for the site to function—for example session, basket, or security." +
        "<br/><br/>" +
        "<strong>Functional / preferences:</strong> may remember choices where enabled." +
        "<br/><br/>" +
        "<strong>Analytics (if used):</strong> may help us understand site use in aggregate." +
        "<br/><br/>" +
        "<strong>3. Third parties</strong>" +
        "<br/>" +
        "Payment providers and hosting/ordering technology may set their own cookies when you use checkout; see their notices." +
        "<br/><br/>" +
        "<strong>4. Consent</strong>" +
        "<br/>" +
        "Where non\u2011essential cookies are used, we request consent via our cookie notice." +
        "<br/><br/>" +
        "<strong>5. Managing cookies</strong>" +
        "<br/>" +
        "You can control cookies in your browser settings. Blocking necessary cookies may affect functionality." +
        "<br/><br/>" +
        "<strong>6. Personal data</strong>" +
        "<br/>" +
        "See our Privacy Policy." +
        "<br/><br/>" +
        "<strong>7. Updates</strong>" +
        "<br/>" +
        "We may update this Cookie Policy; the latest version will appear on this website." +
        "<br/><br/></div>";
}
